import { render, staticRenderFns } from "./SalesByItem.vue?vue&type=template&id=53febe6a&scoped=true"
import script from "./SalesByItem.vue?vue&type=script&lang=js"
export * from "./SalesByItem.vue?vue&type=script&lang=js"
import style0 from "./SalesByItem.vue?vue&type=style&index=0&id=53febe6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53febe6a",
  null
  
)

export default component.exports